import { Outlet } from 'react-router-dom';
import GlubesLogo from './GlubesLogo';
import './Login.scss';

export default function PublicLayout() {
  return (
    <div className="login-page login-page--space">
      <img
        className="login-space-cloud"
        src="/cloud.png"
        alt=""
        aria-hidden="true"
      />

      <div className="login-space-stage">
        <img
          className="login-space-rocket"
          src="/rocket.png"
          alt=""
          aria-hidden="true"
        />
        <Outlet />
      </div>

      <div className="login-space-footer">
        <GlubesLogo className="login-glubes-logo" />
        <footer className="login-copyright">
          © {new Date().getFullYear()} Gobicraft Systems
        </footer>
      </div>
    </div>
  );
}
